import apiClient from './client';
import { CopierSetting } from '../types';

export interface SettingTargetItem {
  targetType: 'ACCOUNT' | 'GROUP';
  targetValue: string;
}

export interface SettingPayload {
  name: string;
  description?: string;
  sourceAccount: string;
  copyMode: 'EQUITY' | 'VOLUME' | 'FIXED';
  copyValue: number;
  status: 'ACTIVE' | 'PAUSED';
  targets: SettingTargetItem[];
}

export const settingsApi = {
  getAll: () =>
    apiClient.get<CopierSetting[]>('/v1/settings').then((r) => r.data),

  getOne: (id: number) =>
    apiClient.get<CopierSetting>(`/v1/settings/${id}`).then((r) => r.data),

  create: (data: SettingPayload) =>
    apiClient.post<CopierSetting>('/v1/settings', data).then((r) => r.data),

  update: (id: number, data: SettingPayload) =>
    apiClient.put<CopierSetting>(`/v1/settings/${id}`, data).then((r) => r.data),

  delete: (id: number) =>
    apiClient.delete(`/v1/settings/${id}`).then((r) => r.data),

  pause: (id: number) =>
    apiClient.post(`/v1/settings/${id}/pause`).then((r) => r.data),

  resume: (id: number) =>
    apiClient.post(`/v1/settings/${id}/resume`).then((r) => r.data),
};
